import React, { useEffect } from 'react'
import Browse from '../organisms/Browse'
import { useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { SET_TAB } from 'dealer-reducers'

const BrowseWrapper = (): JSX.Element => {
  const { pathname } = useLocation()
  const isBrowsing = pathname === '/browsing/browse'

  const notListView = pathname.includes('browsing/offer') || pathname.includes('settings')

  const dispatch = useDispatch()

  useEffect(() => {
    if (notListView) {
      document.body.style.overflow = ''
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      document.body.style.overflow = 'hidden'
    }
  }, [notListView])

  useEffect(() => {
    if (isBrowsing) {
      dispatch(SET_TAB({ tab: 'browse' }))
    }
  }, [isBrowsing, dispatch])

  return (
    <div
      style={{
        visibility: isBrowsing ? 'visible' : 'hidden',
        zIndex: isBrowsing ? 100 : -100
      }}
      className="absolute top-0 left-0 bg-[white] w-screen h-screen overflow-hidden">
      <Browse />
    </div>
  )
}

export default BrowseWrapper
